/*========================================================================
 * $Id: Suggest.js 73821 2013-07-17 11:51:32Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["i18n/i18n", "api/v2/common", "api/v2/search", "backbone", "underscore", "model/tree",  "model/readonlytree", "service/stub", "service/factory", "model/computed"],
function(i18n, Common, Search, Backbone, _, TreeModel, ReadOnlyTreeModel, Stub, ServiceFactory, ComputedModel){

  var Suggest = {};
  
  
  var SuggestResponse = {
      
      mergeResult: function(lhs, rhs) {
        if (lhs == null) return rhs;
        if (rhs == null) return lhs;
        var merged = _.clone(lhs);
        merged.score += rhs.score;
        return merged;
      },  
      
      merge: function(lhs, rhs) {
        if (!lhs) return rhs;
        if (!rhs) return lhs;
        if (!rhs.results) return lhs;
                        
        var rhsKeys = _.keys(rhs.results);
        
        var merged = _.clone(lhs.results) || {};
        for (var i = 0; i < rhsKeys.length; i++) {
          var name = rhsKeys[i];
          merged[name] = SuggestResponse.mergeResult(merged[name], rhs.results[name]);
        } 
               
        var sortedValues = _.sortBy(_.keys(merged), function(name) { return -merged[name].score });
        var results = {};
        for (var i = 0; i < sortedValues.length; ++i) {
          var value = sortedValues[i];
          results[value] = merged[value]; 
        }
        var result = _.clone(lhs);
        result.results = results;
        return result;
      },
      
      parseResults: function(results) {
        var parsed = {};
        for (var i = 0; i < results.length; ++i) {
          parsed[results[i].value] = results[i];
        }
        return parsed;
      },
      
      parse: function(response) {
        var parsed = _.clone(response);
        
        if (response.results) {
         parsed.results =  SuggestResponse.parseResults(response.results);
        }        
        parsed.status_messages = Common.StatusMessages.parse(response.status_messages);
        return parsed;
      }
  }

  var SuggestInputModel = Suggest.SuggestInputModel = TreeModel.extend({
    toJSON: function() {
      var attrs = this.attributes;
      var json = _.clone(attrs);
      if (json.property_constraint) {
        json.property_constraint = Search.SearchRequest.jsonifyQueryExpr(json.property_constraint);
      }
      return json;
    }
  });

  
  var SuggestServiceStub = Suggest.SuggestServiceStub = Stub.extend({
    path: "suggest",
    options: {defaultAjaxRequestTimeoutInMs: 2000}
  });
  
  // TODO: generic service functionality, push to utils
  var SuggestServiceFactory = Suggest.ServiceFactory = function() {}
  
  _.extend(SuggestServiceFactory.prototype, ServiceFactory.prototype, {

    prepareRequest: function (request) {
      request = _.clone(request);

      if (request.source_context && request.source_context.constraints) {
        var query = Common.propertyListToArray(request.source_context.constraints);
        _.each(query, function (query) {
            if (query.filter_base) query.filter_base = Common.propertyListToArray(query.filter_base);
            if (query.filtered) query.filtered = Common.propertyListToArray(query.filtered);
        });
        request.source_context.constraints = query;
      }

      return request;
    },

    call: function (channel, SuggestRequest, callback, options) {
      var stub = new SuggestServiceStub(),
          model = this.createOutput();

      SuggestRequest = this.prepareRequest(SuggestRequest);

      if (!_.isFunction(callback)) return; 
      var mergedResponse = null;
      var errors = null;
      var responseObserver = {
        traceContext: options && options.traceContext
      };
      _.extend(responseObserver, Backbone.Events);
      responseObserver.on("response", function (response) {
        // console.log("response", response);
        var parsed = SuggestResponse.parse(response);
        // console.log("parsed", parsed);
        mergedResponse = SuggestResponse.merge(mergedResponse, parsed);
        // console.log("mergedResponse", mergedResponse);
      });
      
      responseObserver.on("error", function (error) {
        if (!errors) errors = [];  
        errors.push(error);
      });

      var promise = new SuggestServiceStub().cast(channel, SuggestRequest, responseObserver);
      promise.always(function() { 
        try {
          // console.log(mergedResponse);
          callback(mergedResponse, errors);
        } catch (e) {
          if (console && console.error) console.error(e, e.stack);
        }
      });
    },
        

    createInput:  function(attrs,options) { return new SuggestInputModel(attrs, options); },
    createModel:  function(channel, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new SuggestServiceStub();
      options.defaultResponseOptions = {
      };
      return new ComputedModel(this.createWiring(channel,options), options);
    }

    /* createOutput: function(attrs,options) { return new SuggestOutputModel(attrs, options); }, 
    createModel:  function(channel, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new SuggestServiceStub();
      return new SuggestModel(this.createWiring(channel,options), options);
    }*/
  });

  return Suggest;
});
